import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { useHistory, useParams, useRouteMatch } from "react-router-dom/cjs/react-router-dom.min";
import { getOilTypes } from "utils/LaravelApi/LaravelAPI";

export default function TypeOilSelector({ optionSection }) {

  const { path } = useRouteMatch();
  const { typeSlug } = useParams();
  let history = useHistory();
  const [items, setItems] = useState([]);

  useEffect(() => {
    async function go() {
      const oilTypes = await getOilTypes();
      if (oilTypes.success) {
        const types = oilTypes.data.map(item => item.nombre);
        setItems(types);
      }
    }
    go();
  }, []);

  const optionStyle = {
    fontWeight: 'bold',
    textDecoration: 'underline',
    fontFamily: "Nunito Sans, sans-serif",
    fontWeight: '700',
    fontSize: '30px',
    cursor: 'pointer',
  };

  const containerStyle = {
    marginBottom: '40px',
  };

  const redirectTo = (name) => {
    const newPath = path.replace(":typeSlug", typeSlug);
    history.push(`${newPath}/${name}`);
  };

  return (
    <Grid container spacing={2} style={containerStyle}>
      {items.map((item, index) => (
        <Grid item xs={6} key={index} onClick={() => redirectTo(item)}>
          <div style={optionStyle}>
            {item}
          </div>
        </Grid>
      ))}
    </Grid>
  );
}